export { default as companiesReducers } from 'companies/reducers/companies_reducers';



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/reducers/index.js